'use client'

import { FaqItem, IFaqItemProps } from '@/features/faq/faq-item'

export interface IFaqSectionProps {
    title: string
    items: IFaqItemProps[]
}

export const FaqSection = ({ title, items }: IFaqSectionProps) => {
    return (
        <div className="flex flex-col gap-3 pb-8">
            {items.map((item, index) => (
                <FaqItem key={'faq-section' + title + index} {...item} />
            ))}
        </div>
    )
}
